
const sh = require('shelljs')
const { config, error } = require('../common.js')

module.exports = yargs => {

	const { stderr } = sh.exec(
		`cd ${config.get("ops_client_path")} && yarn run dev
		`
	)

	if (/listen EADDRINUSE/.test(stderr))
		error('dev', 'the dev server is already running')
}




// WEBPACK FOOTER //
// ./src/commands/dev.js